/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspaceScheduledIncentive,
    WorkspaceScheduledIncentiveFromJSON,
    WorkspaceScheduledIncentiveFromJSONTyped,
    WorkspaceScheduledIncentiveToJSON,
} from './WorkspaceScheduledIncentive';

/**
 * 
 * @export
 * @interface WorkspaceIncentivesScheduledResponse
 */
export interface WorkspaceIncentivesScheduledResponse {
    /**
     * 
     * @type {Array<WorkspaceScheduledIncentive>}
     * @memberof WorkspaceIncentivesScheduledResponse
     */
    userIncentives: Array<WorkspaceScheduledIncentive>;
    /**
     * Internal user id
     * @type {string}
     * @memberof WorkspaceIncentivesScheduledResponse
     */
    internalUserId: string;
    /**
     * workspace member id
     * @type {string}
     * @memberof WorkspaceIncentivesScheduledResponse
     */
    workspaceMemberId: string;
    /**
     * workspace id
     * @type {string}
     * @memberof WorkspaceIncentivesScheduledResponse
     */
    workspaceId: string;
}

export function WorkspaceIncentivesScheduledResponseFromJSON(json: any): WorkspaceIncentivesScheduledResponse {
    return WorkspaceIncentivesScheduledResponseFromJSONTyped(json, false);
}

export function WorkspaceIncentivesScheduledResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceIncentivesScheduledResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIncentives': ((json['userIncentives'] as Array<any>).map(WorkspaceScheduledIncentiveFromJSON)),
        'internalUserId': json['internalUserId'],
        'workspaceMemberId': json['workspaceMemberId'],
        'workspaceId': json['workspaceId'],
    };
}

export function WorkspaceIncentivesScheduledResponseToJSON(value?: WorkspaceIncentivesScheduledResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIncentives': ((value.userIncentives as Array<any>).map(WorkspaceScheduledIncentiveToJSON)),
        'internalUserId': value.internalUserId,
        'workspaceMemberId': value.workspaceMemberId,
        'workspaceId': value.workspaceId,
    };
}

